import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-apk",
  "use": "icon-apk-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-apk\"><defs><style type=\"text/css\"></style></defs><path d=\"M336 96h352v832H336z\" /><path d=\"M472 864a40 40 0 1 0 80 0 40 40 0 1 0-80 0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/apk.svg
// module id = ugXZ
// module chunks = 65